import * as React from 'react';
import { cn } from '@/lib/utils';

type Tone = 'neutral' | 'up' | 'down' | 'warn' | 'brand';

const toneText: Record<Tone, string> = {
  neutral: 'text-ink-0',
  up: 'text-up',
  down: 'text-down',
  warn: 'text-warn',
  brand: 'text-brand',
};

interface KpiCardProps {
  label: string;
  value: React.ReactNode;
  sub?: React.ReactNode;
  tone?: Tone;
  icon?: React.ReactNode;
  className?: string;
  action?: React.ReactNode;
}

/**
 * 通用 KPI 卡。仪表板 / 资金账户大屏等监控页面共用。
 */
export function KpiCard({ label, value, sub, tone = 'neutral', icon, className, action }: KpiCardProps) {
  return (
    <div className={cn('relative rounded-lg border border-line bg-bg-2 p-4 elev-card kpi-bar', className)}>
      <div className="flex items-start justify-between gap-3">
        <div className="text-xs uppercase tracking-wide text-ink-2">{label}</div>
        {icon && <div className="text-ink-3">{icon}</div>}
      </div>
      <div className={cn('mt-2 text-2xl font-bold num', toneText[tone])}>{value}</div>
      {sub && <div className="mt-1 text-xs text-ink-2">{sub}</div>}
      {action && <div className="absolute right-3 bottom-3">{action}</div>}
    </div>
  );
}
